import React from 'react'
import { Outlet } from 'react-router'

const YearWrapper = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default YearWrapper
